import React from 'react';
import { CheckCheckIcon, UsersIcon } from 'lucide-react';
import { testimonials } from '../data/megaPack';
export function Testimonials() {
  return <section className="bg-cream-100 py-10 sm:py-16" aria-label="Testimonios" data-id="element-262" data-mp="3ksgzabf82nei">
      <div className="mx-auto max-w-2xl px-5 sm:px-8" data-id="element-263" data-mp="3fy2z7vpm7s3i">
        <p className="text-center font-display text-[0.7rem] font-700 uppercase tracking-[0.2em] text-teal-600 sm:text-xs" data-id="element-264" data-mp="3b0uilzk47w4d">
          Lo que cuentan quienes ya lo usan
        </p>

        {/* Grupo de testimonios presentado como una conversación */}
        <div className="mt-4 overflow-hidden rounded-2xl shadow-card ring-1 ring-teal-900/10 sm:mt-6" data-id="element-265" data-mp="31yl5r31djqnt">
          <div className="flex items-center gap-3 bg-teal-800 px-4 py-3" data-id="element-266" data-mp="2x11ri34ofdvv">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-cream-50/15" data-id="element-267" data-mp="2s309zmmwfmmi">
              <UsersIcon className="h-4 w-4 text-cream-50" aria-hidden="true" data-id="element-268" data-mp="v8wtc9wl3kcp" />
            </span>
            <div className="min-w-0" data-id="element-269" data-mp="qavanq32ln1r">
              <p className="truncate font-display text-sm font-700 text-cream-50" data-id="element-270" data-mp="h5y7ibcyv721">
                Familias acompañantes
              </p>
              <p className="truncate text-[0.7rem] text-cream-100/70" data-id="element-271" data-mp="m62p64pm27tu">
                Mariana, Claudia, Sofía y +2.500 más
              </p>
            </div>
          </div>

          <ul className="space-y-3 bg-[#ece5dd] px-3 py-4 sm:space-y-4 sm:px-5 sm:py-5" data-id="element-272" data-mp="c6ljhnacztxv">
            {testimonials.map(item => <li key={item.name} className="flex items-end gap-2" data-id="element-273" data-mp="zxr1a7zv0wat">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-teal-700 font-display text-[0.65rem] font-800 text-cream-50" aria-hidden="true" data-id="element-274" data-mp="14w2b4iq5n6t1">
                  {item.initials}
                </span>
                <figure className="relative max-w-[88%] rounded-2xl rounded-bl-md bg-white px-3.5 py-2.5 shadow-sm" data-id="element-275" data-mp="1ivk4lbeeb88q">
                  <figcaption data-id="element-276" data-mp="1nma80j39h10s">
                    <p className={['font-display text-[0.8rem] font-700', item.accent].join(' ')} data-id="element-277" data-mp="1nnla8eh260ps">
                      {item.name}
                    </p>
                    <p className="text-[0.65rem] text-clay/80" data-id="element-278" data-mp="1ogj8dv7qg0bj">
                      {item.location} — {item.role}
                    </p>
                  </figcaption>
                  <blockquote className="mt-1.5 text-[0.85rem] leading-relaxed text-ink/85 sm:text-[0.9rem]" data-id="element-279" data-mp="1eiv34bci3af4">
                    {item.quote}
                  </blockquote>
                  <p className="mt-1 flex items-center justify-end gap-1 text-[0.6rem] text-clay/70" data-id="element-280" data-mp="19qbrvl1acrdh">
                    {item.time}
                    <CheckCheckIcon className="h-3 w-3 text-teal-500" aria-hidden="true" data-id="element-281" data-mp="10s9urgkoaivh" />
                  </p>
                </figure>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}